module.exports = __webpack_public_path__ + "static/media/default-picture.90b9161a.svg";